module.exports = __webpack_public_path__ + "static/media/papers.co-bd75-anime-sky-cloud-spring-art-illustration-35-3840x2160-4k-wallpaper_resized.2d3b31ec.jpg";